import { getUsersByIds } from './GetUsersByIds';
import { getChildOffices } from './GetChildOffices';

/**
 * Users Service
 * Provides business logic layer for users operations
 */
export const UsersService = {
  getUsersByIds,
  getChildOffices,
};
